import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Box, Collapse, Fade, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import MenuJson from 'assets/menu.json'
import Icon from 'components/icon'
import type { SidebarMenuProps, UserProps } from 'modules/types'
import SidebarStyle from './style'

const Sidebar = () => {
    const [hover, setHover] = useState<boolean>(false)
    const permissions = useSelector((state: { user: UserProps }) => state.user.user.permissions)

    const onMouseEvent = (state: boolean) => setHover(state)

    const visible = (MenuJson as SidebarMenuProps[]).filter(m =>
        m.hidden ? false : m.permission ? permissions.includes(m.permission) : true
    )

    return (
        <Box {...SidebarStyle.Container}>
            <Collapse
                orientation='horizontal'
                in={hover}
                collapsedSize={80}
                onMouseEnter={() => onMouseEvent(true)}
                onMouseLeave={() => onMouseEvent(false)}
            >
                <Box {...SidebarStyle.Wrapper}>
                    {visible.map(({ icon, name, path, menu }, index) => (
                        <Link {...SidebarStyle.Link} key={index} to={(menu ?? []).length > 0 ? (menu ?? [])[0].path : path}>
                            <Box {...SidebarStyle.Button}>
                                <Box {...SidebarStyle.Icon}>
                                    <Icon icon={icon ?? ''} />
                                </Box>
                                <Fade in={hover}>
                                    <Typography {...SidebarStyle.Title}>{name}</Typography>
                                </Fade>
                            </Box>
                        </Link>
                    ))}
                </Box>
            </Collapse>
        </Box>
    )
}

export default Sidebar
